/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CAFMember } from '../models';
// @ts-ignore
import type { CafWithDailyCount } from '../models';
// @ts-ignore
import type { InputCreateCAFMember } from '../models';
// @ts-ignore
import type { InputEditCAFMember } from '../models';
/**
 * AdminCafMemberApi - axios parameter creator
 * @export
 */
export const AdminCafMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary All caf members
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCafMembers: async (filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cafMember/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change caf profile picture
         * @param {number} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCafProfilePicture: async (id: number, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeCafProfilePicture', 'id', id)
            const localVarPath = `/admin/cafMember/{id}/change-profile-picture`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create caf member
         * @param {InputCreateCAFMember} [inputCreateCAFMember] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCafMember: async (inputCreateCAFMember?: InputCreateCAFMember, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cafMember/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCreateCAFMember, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Daily practice for caf member | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {Array<number>} [ids] 
         * @param {string} [day] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyPracticeForCafMember: async (ids?: Array<number>, day?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cafMember/dailyPractice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (day !== undefined) {
                localVarQueryParameter['day'] = day;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete caf member
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCafMember: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCafMember', 'id', id)
            const localVarPath = `/admin/cafMember/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Demote caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoteCafMember: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('demoteCafMember', 'id', id)
            const localVarPath = `/admin/cafMember/{id}/demote`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Edit caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {InputEditCAFMember} [inputEditCAFMember] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCafMember: async (id: number, inputEditCAFMember?: InputEditCAFMember, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editCafMember', 'id', id)
            const localVarPath = `/admin/cafMember/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputEditCAFMember, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"CAFMember\"] 
         * @summary Get admin caf member by id | Permission required: [\"readOne\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCafMemberById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminCafMemberById', 'id', id)
            const localVarPath = `/admin/cafMember/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Promote caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteCafMember: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('promoteCafMember', 'id', id)
            const localVarPath = `/admin/cafMember/{id}/promote`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCafMemberApi - functional programming interface
 * @export
 */
export const AdminCafMemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCafMemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary All caf members
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allCafMembers(filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CAFMember>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allCafMembers(filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.allCafMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change caf profile picture
         * @param {number} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCafProfilePicture(id: number, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCafProfilePicture(id, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.changeCafProfilePicture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create caf member
         * @param {InputCreateCAFMember} [inputCreateCAFMember] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCafMember(inputCreateCAFMember?: InputCreateCAFMember, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAFMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCafMember(inputCreateCAFMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.createCafMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Daily practice for caf member | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {Array<number>} [ids] 
         * @param {string} [day] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dailyPracticeForCafMember(ids?: Array<number>, day?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CafWithDailyCount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dailyPracticeForCafMember(ids, day, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.dailyPracticeForCafMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete caf member
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCafMember(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCafMember(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.deleteCafMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Demote caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async demoteCafMember(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAFMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.demoteCafMember(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.demoteCafMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Edit caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {InputEditCAFMember} [inputEditCAFMember] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCafMember(id: number, inputEditCAFMember?: InputEditCAFMember, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAFMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCafMember(id, inputEditCAFMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.editCafMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"CAFMember\"] 
         * @summary Get admin caf member by id | Permission required: [\"readOne\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCafMemberById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAFMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCafMemberById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.getAdminCafMemberById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Promote caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteCafMember(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CAFMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteCafMember(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCafMemberApi.promoteCafMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCafMemberApi - factory interface
 * @export
 */
export const AdminCafMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCafMemberApiFp(configuration)
    return {
        /**
         * 
         * @summary All caf members
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCafMembers(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CAFMember>> {
            return localVarFp.allCafMembers(filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change caf profile picture
         * @param {number} id 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCafProfilePicture(id: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.changeCafProfilePicture(id, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create caf member
         * @param {InputCreateCAFMember} [inputCreateCAFMember] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCafMember(inputCreateCAFMember?: InputCreateCAFMember, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember> {
            return localVarFp.createCafMember(inputCreateCAFMember, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
         * @summary Daily practice for caf member | Permission required: [\"readAll\", \"ServiceRequest\"]
         * @param {Array<number>} [ids] 
         * @param {string} [day] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dailyPracticeForCafMember(ids?: Array<number>, day?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CafWithDailyCount>> {
            return localVarFp.dailyPracticeForCafMember(ids, day, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete caf member
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCafMember(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteCafMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Demote caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoteCafMember(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember> {
            return localVarFp.demoteCafMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Edit caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {InputEditCAFMember} [inputEditCAFMember] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCafMember(id: number, inputEditCAFMember?: InputEditCAFMember, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember> {
            return localVarFp.editCafMember(id, inputEditCAFMember, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"CAFMember\"] 
         * @summary Get admin caf member by id | Permission required: [\"readOne\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCafMemberById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember> {
            return localVarFp.getAdminCafMemberById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"CAFMember\"] 
         * @summary Promote caf member | Permission required: [\"update\", \"CAFMember\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteCafMember(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember> {
            return localVarFp.promoteCafMember(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCafMemberApi - interface
 * @export
 * @interface AdminCafMemberApi
 */
export interface AdminCafMemberApiInterface {
    /**
     * 
     * @summary All caf members
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    allCafMembers(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CAFMember>>;

    /**
     * 
     * @summary Change caf profile picture
     * @param {number} id 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    changeCafProfilePicture(id: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary Create caf member
     * @param {InputCreateCAFMember} [inputCreateCAFMember] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    createCafMember(inputCreateCAFMember?: InputCreateCAFMember, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember>;

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Daily practice for caf member | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {Array<number>} [ids] 
     * @param {string} [day] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    dailyPracticeForCafMember(ids?: Array<number>, day?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CafWithDailyCount>>;

    /**
     * 
     * @summary Delete caf member
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    deleteCafMember(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     *  **Permission required**: [\"update\", \"CAFMember\"] 
     * @summary Demote caf member | Permission required: [\"update\", \"CAFMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    demoteCafMember(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember>;

    /**
     *  **Permission required**: [\"update\", \"CAFMember\"] 
     * @summary Edit caf member | Permission required: [\"update\", \"CAFMember\"]
     * @param {number} id 
     * @param {InputEditCAFMember} [inputEditCAFMember] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    editCafMember(id: number, inputEditCAFMember?: InputEditCAFMember, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember>;

    /**
     *  **Permission required**: [\"readOne\", \"CAFMember\"] 
     * @summary Get admin caf member by id | Permission required: [\"readOne\", \"CAFMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    getAdminCafMemberById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember>;

    /**
     *  **Permission required**: [\"update\", \"CAFMember\"] 
     * @summary Promote caf member | Permission required: [\"update\", \"CAFMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApiInterface
     */
    promoteCafMember(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CAFMember>;

}

/**
 * AdminCafMemberApi - object-oriented interface
 * @export
 * @class AdminCafMemberApi
 * @extends {BaseAPI}
 */
export class AdminCafMemberApi extends BaseAPI implements AdminCafMemberApiInterface {
    /**
     * 
     * @summary All caf members
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public allCafMembers(filter?: string, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).allCafMembers(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change caf profile picture
     * @param {number} id 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public changeCafProfilePicture(id: number, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).changeCafProfilePicture(id, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create caf member
     * @param {InputCreateCAFMember} [inputCreateCAFMember] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public createCafMember(inputCreateCAFMember?: InputCreateCAFMember, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).createCafMember(inputCreateCAFMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequest\"] 
     * @summary Daily practice for caf member | Permission required: [\"readAll\", \"ServiceRequest\"]
     * @param {Array<number>} [ids] 
     * @param {string} [day] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public dailyPracticeForCafMember(ids?: Array<number>, day?: string, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).dailyPracticeForCafMember(ids, day, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete caf member
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public deleteCafMember(id: number, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).deleteCafMember(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"CAFMember\"] 
     * @summary Demote caf member | Permission required: [\"update\", \"CAFMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public demoteCafMember(id: number, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).demoteCafMember(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"CAFMember\"] 
     * @summary Edit caf member | Permission required: [\"update\", \"CAFMember\"]
     * @param {number} id 
     * @param {InputEditCAFMember} [inputEditCAFMember] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public editCafMember(id: number, inputEditCAFMember?: InputEditCAFMember, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).editCafMember(id, inputEditCAFMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"CAFMember\"] 
     * @summary Get admin caf member by id | Permission required: [\"readOne\", \"CAFMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public getAdminCafMemberById(id: number, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).getAdminCafMemberById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"CAFMember\"] 
     * @summary Promote caf member | Permission required: [\"update\", \"CAFMember\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCafMemberApi
     */
    public promoteCafMember(id: number, options?: RawAxiosRequestConfig) {
        return AdminCafMemberApiFp(this.configuration).promoteCafMember(id, options).then((request) => request(this.axios, this.basePath));
    }
}

